import styled from "styled-components";
import { FONT_WEIGHT, FONTS } from "../../../constants/Styles";
import Link from "next/link";

export const Title = styled.div`
  font-size: 1.5rem;
  font-weight: ${FONT_WEIGHT.weight700};
  font-family: ${FONTS.spaceGrotesk};
`;

export const Subtitle = styled.div`
  font-size: 1rem;
  font-weight: ${FONT_WEIGHT.weight500};
  font-family: ${FONTS.spaceGrotesk};
`;

export const HorizontalContainer = styled.div<{ gap?: string }>`
  display: flex;
  gap: ${({ gap }) => gap || "1rem"};
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

export const VerticalContainer = styled.div<{ gap?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ gap }) => gap || "1rem"};
`;

export const PreviewImg = styled.img`
  max-width: 20rem;
  cursor: pointer;
`;

export const DownloadableFile = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const Remove = styled.div`
  cursor: pointer;
  display: flex;
`;

export const FileLink = styled(Link)`
  min-width: 0;
  overflow-wrap: anywhere;
  flex: 1;
`;
